module.exports = __webpack_public_path__ + "assets/images/PhoneGear.4084c.png";